/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { TextWrap } from "@cd2/text"
import { useSiteBanner } from "./useSiteBanner"
import { brandColors } from "../../Components/EOSThemeProvider"
import { Button, Grid, useLocalStorage } from "@cd2/components"

export function SiteBanner() {
  const banner = useSiteBanner()
  if (!banner) {
    return null
  }

  return (
    <div
      css={css`
        position: sticky;
        width: 100%;
        background: white;
        left: 0;
        bottom: 0;
        z-index: 11;
        text-align: center;
        padding: 16px;
        background: #fff8e1;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
      `}
    >
      <Grid columns={["auto", "max-content"]} gap={16} alignItems="center">
        <TextWrap color={brandColors.night} rawHtml={{ makeLinksOpenInNewTab: true }}>
          {banner}
        </TextWrap>
      </Grid>
    </div>
  )
}
